import { runInspectionFn } from '../utils/runInspectionFn';
import { checkModifierFn } from './helper';
import { PermissionV2 } from './enum/PermissionV2';
import {checkPermissionFn} from "../../AccessChecker/checkPermissionFn";

export class PermissionResult {
    constructor(permissionKeys, defaultRequiredLevel, defaultInhibitorModifiers = [], permissionCheckMethod = 'AND') {
        this.keys = permissionKeys || [];
        this.defaultRequiredLevel = defaultRequiredLevel;
        this.defaultInhibitorModifiers = defaultInhibitorModifiers;
        this.permissionCheckMethod = permissionCheckMethod;
    }

    // returns: boolean
    hasPermissionTo(requiredLevel, inhibitorModifiers) {
        // type: boolean
        const permission = runInspectionFn(
            checkPermissionFn,
            this.keys,
            this.permissionCheckMethod, // default as 'AND'
            this.getRequiredLevel(requiredLevel),
        );

        const permissionInhibitedByModifiers = this.hasSomeModifier(
            this.getInhibitorModifiers(inhibitorModifiers),
        ); // True == No Permission

        return permission && !permissionInhibitedByModifiers;
    }

    getRequiredLevel(requiredLevel) {
        const isNotNull = value => !(value === undefined || value === null);

        if (isNotNull(requiredLevel))
            return requiredLevel;

        return isNotNull(this.defaultRequiredLevel) ? this.defaultRequiredLevel : PermissionV2.update;
    }

    getInhibitorModifiers(inhibitorModifiers) {
        const isNotNull = value => !(value === undefined || value === null);

        if (isNotNull(inhibitorModifiers))
            return inhibitorModifiers;

        return this.defaultInhibitorModifiers;
    }

    /**
     * true whenever ANY of the item in modifierArr is present in the key's modifier [OR conditional]
     * true if modifierArr is [] / null / undefined
     * @param {String[]} modifierArr eg: ['M1', 'M3']
     * @returns boolean
     */
    hasSomeModifier(modifierArr) {
        return checkModifierFn(this.keys, modifierArr, 'some');
    }

    /**
     * true only when ALL of the items in modifierArr is present in the key's modifier [AND conditional]
     * true if modifierArr is [] / null / undefined
     * @param {String[]} modifierArr eg: ['M1', 'M3']
     * @returns boolean
     */
    hasEveryModifier(modifierArr) {
        if (modifierArr === undefined) {
            // eslint-disable-next-line no-param-reassign
            modifierArr = this.defaultModifiers;
        }

        return checkModifierFn(this.keys, modifierArr, 'every');
    }
}
